
import {Component, Vue, Prop} from "vue-property-decorator";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import CameraTypeIcon from "@/components/CameraTypeIcon.vue";

@Component({
  components: {
    CameraTypeIcon,
  }
})
export default class EventCell extends Vue {
  @Prop() cell: IReport.ITableProp;
  @Prop() entity: IReport.ReportEntityType;

  get value() { return this.entity[this.cell.prop]; }
}
